function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1 4C1 2.34315 2.34315 1 4 1H20C21.6569 1 23 2.34315 23 4V20C23 21.6569 21.6569 23 20 23H4C2.34315 23 1 21.6569 1 20V4ZM7.40994 22H4.99994C4.86867 22 4.73937 21.9916 4.61255 21.9752L10.4099 16.17L12.4099 18.17L17.2899 13.29L14.9999 11H20.9999V17L18.7099 14.71L12.4099 21L10.4099 19L7.40994 22ZM6.35901 8.17224C6.70825 12.488 12.1323 12.0051 12.7058 8.14201V8.15707C13.8253 7.76102 14.5997 7.11961 14.5997 6.21043L12.3032 5.56155L11.3164 3.20753L7.65723 3L6.68176 5.44086L4.23706 6.12744C4.23706 7.08565 5.11792 7.76476 6.35901 8.17224ZM3.50537 15.2943C3.71106 14.7736 3.93787 14.3207 4.14661 13.9509C4.5719 13.1975 5.29553 12.687 6.10303 12.3765L6.8335 12.0956L9 13.5L12.4099 12.0956C13.8169 11.9722 14.6978 12.3839 15.6315 13.5342L12.4099 16.7558L10.4094 14.7553L5.5 19.5C4.59753 19.391 2.99994 18.4219 2.99994 17.5C2.99994 16.5221 3.0479 16.4065 3.30941 15.776L3.30942 15.776C3.36468 15.6427 3.42948 15.4865 3.50537 15.2943Z",
  fill: "#939EAA"
});

function SvgFarmerPlans(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFarmerPlans);
export default __webpack_public_path__ + "static/media/farmer-plans.7e4eb220.svg";
export { ForwardRef as ReactComponent };